<template>
  <div :class="['gantt_skin_terrace', $style.h_100]">
    <div :class="['dhx_gantt_container', $style.h_100]">
      <div
        id="new_gantt_here"
        :class="$style.h_100"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ganttViewConstructor from './init';
import LoadRequiredDataMixin from '../../mixins/LoadRequiredData';

export default {
  name: 'GanttView',
  mixins: [LoadRequiredDataMixin],
  emits: ['ready'],
  computed: {
    height() {
      if (this.$store.getters.isLink) {
        return '100%';
      }

      const str = this.$store.getters.getWindowParams.height;

      return str ? parseInt(str.match(/\d+/), 10) : 0;
    },
  },
  watch: {
    '$route.params.projectId': {
      handler(val) {
        if (val && !this.$store.state.baselines.projectBaselines[val]) {
          this.$store.dispatch('baselines/fetchBaselines', val);
        }
      },
      immediate: true,
    },
    height: {
      handler: _.debounce((oldVal, newVal) => {
        if (oldVal !== newVal) {
          ganttViewConstructor.resizeGantt();
        }
      }, 100),
      immediate: true,
    },
    isLoadedRequiredData: {
      handler(val) {
        if (val) {
          this.$emit('ready');
        }
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    ganttViewConstructor.destroyPreviousInstance();
  },
};
</script>

<style lang="less" module>

// Gantt 8 styles are included in the top of app/public/less/_gantt.less

.h_100 {
  height: 100%;
}

</style>
